import { useMutation, useQueryClient } from "react-query";
import { RestError } from "../../services/rest-service/RestService";
import { IUICustomizationSettingsDTO } from "../../services/ui-customization-data-service/Models";
import UICustomizationDataService from "../../services/ui-customization-data-service/UICustomizationDataService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { keys } from "./Keys";
import { keys as userKeys } from "../user-role-administration/Keys";

export type UseSaveUICustomizationSettingsParameters = {
    userID: number,
} & BaseUseMutationParameters<void, IUICustomizationSettingsDTO | undefined>;

export function useSaveUICustomizationSettings({
    userID,
    onError,
    onSuccess
}: UseSaveUICustomizationSettingsParameters) {
    const queryClient = useQueryClient();

    return useMutation<void, RestError, IUICustomizationSettingsDTO | undefined>(
        (settings) => {
            return UICustomizationDataService.saveUICustomizationSettings(
                userID,
                settings
            );
        },
        {
            onError: onError,
            onSuccess: onSuccess,
            onSettled: () => {
                queryClient.invalidateQueries(keys.userSettings(userID));
                queryClient.invalidateQueries(keys.userEffectiveSettings(userID));
                queryClient.invalidateQueries(keys.presetLists());
                queryClient.invalidateQueries(keys.presets());
                queryClient.invalidateQueries(keys.presetsUserLists());
                queryClient.invalidateQueries(userKeys.userLists());
            }
        }
    );
}
